<template>
    <ValidationObserver v-slot="{ invalid }">
        <v-card :class="{ jsCardHasError: invalid }">
            <v-card-text>
                <form
                    action=""
                    method="POST"
                    @submit.prevent="save"
                >
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="question"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Question"
                                    name="question"
                                    id="question"
                                    v-model="question"
                                    outlined
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="answer"
                                rules="required|max:255"
                                v-slot="{ errors }"
                            >
                                <v-textarea
                                    label="Answer"
                                    name="answer"
                                    id="answer"
                                    v-model="answer"
                                    outlined
                                    :error-messages="errors[0]"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider
                                name="order"
                                rules="integer"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    label="Order"
                                    name="order"
                                    id="order"
                                    v-model="order"
                                    outlined
                                    :error-messages="errors[0]"
                                    type="number"
                                />
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                </form>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    v-if="faqId"
                    text
                    @click="toggleDeleteModal(true)"
                    :disabled="invalid"
                >
                    Delete FAQ
                </v-btn>
                <v-spacer />
                <v-btn
                    type="submit"
                    color="primary"
                    @click="save"
                >
                    <v-icon
                        left
                        small
                    >
                        fas fa-save
                    </v-icon>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex';
import store from '../../../../store/store';

export default {
    computed: {
        question: {
            get: function() {
                return store.state.faqEditor.question;
            },
            set: function(value) {
                this.setQuestion(value);
            }
        },

        answer: {
            get: function() {
                return store.state.faqEditor.answer;
            },
            set: function(value) {
                this.setAnswer(value);
            }
        },

        order: {
            get: function() {
                return store.state.faqEditor.order;
            },
            set: function(value) {
                this.setOrder(value);
            }
        },

        ...mapState('faqEditor', ['faqId']),
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'faqEditor/getData',
            saveData: 'faqEditor/saveData'
        }),

        ...mapMutations({
            setQuestion: 'faqEditor/setQuestion',
            setAnswer: 'faqEditor/setAnswer',
            setOrder: 'faqEditor/setOrder',
            toggleDeleteModal: 'faqEditor/toggleDeleteModal'
        }),

        save() {
            this.saveData();
        }
    }
};
</script>
